module.exports = __webpack_public_path__ + "img/mycamper-logo-with-text.0d46860.svg";